module.exports = __webpack_public_path__ + "static/media/u21a-c_a7.ace29075.mp3";